var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAhand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 87,
    viewBox: "0 0 88 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.1016 81.0001C47.1016 81.0001 47.8246 60.6119 48.1138 57.8645C48.403 55.1172 47.68 52.2252 48.1138 48.4657C48.1138 48.4657 48.4736 46.5859 47.643 43.2602C46.8124 39.9345 44.3543 35.7412 45.2219 24.8964C45.2219 24.8964 45.1455 22.5342 45.0391 21.6666C44.9327 20.7991 45.0287 19.4491 45.5111 18.4855C45.9934 17.5219 46.6678 14.726 48.9814 13.376C51.295 12.0261 54.0585 9.88601 56.5005 11.3516C56.5005 11.3516 57.368 11.6408 57.8504 15.1112C58.3328 18.5815 58.622 19.1599 58.814 20.0275C58.814 20.0275 59.5856 23.691 59.9708 25.6182C60.356 27.5465 61.4931 31.7873 64.2995 31.4021C64.2995 31.4021 66.5367 31.3894 66.8212 28.6004",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7163 16.1719C50.7163 16.1719 51.0726 17.5218 51.9066 19.257C52.7407 20.9922 53.7043 22.4381 54.5719 24.7517C55.4394 27.0653 56.8854 30.8248 59.7774 30.5356C59.7774 30.5356 60.7409 30.5356 60.9341 29.3788",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1981 6.72926C63.1981 6.72926 64.8002 3.15828 66.82 2.86909C68.8397 2.5799 70.1573 2.79968 71.5385 4.41107C72.9197 6.02247 72.31 10.859 72.31 10.859C72.31 10.859 72.1169 14.0505 72.31 17.3288C72.5032 20.6071 72.2244 26.1007 72.2244 26.1007C72.2244 26.1007 72.3783 29.0886 69.1289 29.3778C69.1289 29.3778 66.5261 29.3859 66.0438 27.3534C65.5903 25.4401 65.3694 24.1445 65.1762 22.5332C65.0027 21.0849 64.5978 17.6168 64.5018 14.0505C64.4058 10.4842 64.791 9.42339 64.1166 7.68822C63.9465 7.25559 63.6215 6.9421 63.1981 6.72926ZM63.1981 6.72926C61.928 6.09187 59.7775 6.36372 58.3315 7.01382C56.4032 7.88141 56.1533 11.1759 56.1533 11.1759",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.042 5.36749C72.042 5.36749 73.5632 3.15805 75.5875 3.44724C77.6119 3.73644 80.0214 5.7608 79.7323 10.0987C79.4431 14.4366 78.4795 16.1718 78.3823 19.9313C78.2851 23.6909 76.3579 25.8112 74.6228 25.9084C72.8876 26.0044 72.4156 25.0963 72.3161 23.7406",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.3209 76.0353C69.3209 76.0353 69.0317 62.6364 69.3209 58.4905C69.6101 54.3457 69.4169 52.4174 69.8033 49.7186C70.1885 47.0199 70.1885 48.3097 70.2857 45.929C70.3828 43.5484 72.0208 41.7172 72.8884 41.2348C73.756 40.7524 75.8764 38.7281 77.5155 36.2225C79.1547 33.7158 81.6603 31.4994 83.0102 30.1494C84.3602 28.7995 84.3602 28.7034 84.8414 24.8479C85.3238 20.9924 85.805 15.6712 86.1914 14.6683C86.5766 13.6653 86.6737 13.065 86.1914 10.859C85.709 8.65302 85.4198 6.91785 85.613 5.08552C85.8062 3.25434 86.2874 1.22998 84.9386 1.0368C83.5886 0.843615 80.6932 1.14322 79.7308 8.74903C79.7308 8.74903 79.5399 13.4722 82.529 13.7614",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M52.7256 20.8452C52.7256 20.8452 49.5595 21.0835 47.5352 20.8452",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9071 19.2571C51.9071 19.2571 49.56 18.1963 48.6924 17.0396",
    stroke: "#F9BF2E",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1367 68.1406H19.8633L17.9102 74H11.6797L22.2656 45.5625H27.6953L38.3398 74H32.1094L30.1367 68.1406ZM21.4453 63.3945H28.5547L24.9805 52.75L21.4453 63.3945Z",
    fill: "url(#paint0_diamond)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_diamond",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2424 62.8929) rotate(88.0754) scale(45.1147 45.0815)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD458",
    stopOpacity: 0.78
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BF2E"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAhand);
export default __webpack_public_path__ + "static/media/Ahand.2610c9f836e1a8021394fc6f6e2fdece.svg";
export { ForwardRef as ReactComponent };